<template>
    <div class="retail-personalization">
        <personalization />
    </div>
</template>

<style>
.retail-personalization {
    display: inline-block;
    margin-top: 5px;
}

.retail-personalization .personalization {
    border: 1px solid transparent;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    cursor: pointer;
    display: inline-block;
    font-size: 15px;
    height: 100px;
    margin-top: -5px;
    text-align: center;
    transition: background-color 0.125s ease-in-out;
    vertical-align: bottom;
}

.retail-personalization .personalization:active {
    background-color: #ffffff;
    border-color: #e9eaee #e9eaee transparent #e9eaee;
}

.retail-personalization .personalization.disabled {
    background-color: transparent;
    border-color: transparent;
    pointer-events: none;
}

.retail-personalization .personalization .button.button-personalization {
    padding: 30px 10px 10px 10px;
}

.retail-personalization .personalization .button.button-personalization > h3 {
    color: #6d6d6d;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    margin: 0px 0px 14px 0px;
    text-transform: uppercase;
    transition: color 0.25s ease-in-out;
}

.retail-personalization .personalization.disabled .button.button-personalization > h3 {
    color: #9b9b9b;
}

.retail-personalization .personalization .button.button-personalization > p {
    color: #4d545f;
    line-height: 18px;
    margin: 0px 0px 0px 0px;
    transition: color 0.25s ease-in-out;
}

.retail-personalization .personalization.disabled .button.button-personalization > p {
    color: #9b9b9b;
}

@media screen and (max-height: 1340px) {

    .retail-personalization .personalization {
        height: 75px;
    }

    .retail-personalization .personalization .button.button-personalization {
        padding-top: 22px;
    }

    .retail-personalization .personalization .button.button-personalization > h3 {
        font-size: 12px;
        line-height: 12px;
        margin: 0px 0px 12px 0px;
        text-transform: uppercase;
    }

    .retail-personalization .personalization .button.button-personalization > p {
        font-size: 12px;
    }
}
</style>

<script>
export const RetailPersonalization = {
    name: "retail-personalization"
};

export default RetailPersonalization;
</script>
